import { useState, useEffect, useCallback } from 'react'
import { listAuditLogs } from '../services/adminApi.js'
import type { AuditLog, PaginatedResponse } from '../types/index.js'

export function useAdminLogs(initialPage = 1, initialLimit = 20) {
  const [data, setData] = useState<PaginatedResponse<AuditLog> | null>(null)
  const [loading, setLoading] = useState(true)
  const [error, setError] = useState<string | null>(null)
  const [page, setPage] = useState(initialPage)
  const limit = initialLimit

  const fetch = useCallback(async (p: number) => {
    setLoading(true)
    setError(null)
    try {
      const result = await listAuditLogs(p, limit)
      setData(result)
    } catch (err) {
      setError(err instanceof Error ? err.message : 'Failed to load audit logs')
    } finally {
      setLoading(false)
    }
  }, [limit])

  useEffect(() => { void fetch(page) }, [fetch, page])

  return { data, loading, error, page, setPage, refresh: () => fetch(page) }
}
